import {
  canAttemptReload,
  isChunkLoadError,
} from "$/lib/utils/chunk-error-handler"
import { Body, H1 } from "@repo/ui/components/ui/typography"
import { useTranslations } from "use-intl"
import ErrorComponent from "./error-component"

const ChunkReloadingMessage = () => {
  const t = useTranslations("alfred.components.chunkLoadError")
  return (
    <div className="flex flex-col items-center justify-center size-full gap-2 p-6 text-center">
      <Body className="text-muted-foreground">{t("reloading")}</Body>
    </div>
  )
}

const ChunkLoadFailedMessage = () => {
  const t = useTranslations("alfred.components.chunkLoadError")
  return (
    <div className="flex flex-col items-center justify-center size-full gap-2 p-6 text-center md:gap-4">
      <div className="space-y-2">
        <H1 weight="bold" className="text-3xl sm:text-4xl">
          {t("title")}
        </H1>
        <Body className="text-muted-foreground">{t("description")}</Body>
        <button
          type="button"
          onClick={() => {
            window.location.reload()
          }}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          {t("reload")}
        </button>
      </div>
    </div>
  )
}

/**
 * The router's error screen. Needs the texts, so it must render inside an
 * IntlProvider.
 */
export const RouteErrorComponent = ({ error }: { error: Error }) => {
  // If this is a chunk loading error, auto-reload or show fallback
  if (isChunkLoadError(error)) {
    // If we can still attempt a reload, trigger it
    if (canAttemptReload()) {
      window.location.reload()
      return <ChunkReloadingMessage />
    }

    // Max retries exhausted, show error with manual reload option
    return <ChunkLoadFailedMessage />
  }
  return <ErrorComponent />
}
